import { api, getToken } from './client';

export const ordensCompraApi = {
  listar: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/ordens-compra${qs ? `?${qs}` : ''}`);
  },
  obter: (id) => api.get(`/ordens-compra/${id}`),
  criar: (dados) => api.post('/ordens-compra', dados),
  cancelar: (id) => api.post(`/ordens-compra/${id}/cancelar`)
};

export const notasEntradaApi = {
  listar: () => api.get('/notas-entrada'),
  obter: (id) => api.get(`/notas-entrada/${id}`),
  criar: (dados) => api.post('/notas-entrada', dados),
  preview: async (arquivo) => {
    const formData = new FormData();
    formData.append('arquivo', arquivo);
    const res = await fetch('/api/notas-entrada/preview', {
      method: 'POST',
      headers: { Authorization: `Bearer ${getToken()}` },
      body: formData
    });
    const corpo = await res.json();
    if (!res.ok) throw new Error(corpo.erro || 'Erro ao ler o XML');
    return corpo;
  }
};
